export const camposHorario = ['hora_recogida', 'hora_llegada', 'hora_retorno_recogida', 'hora_retorno_llegada'];
export function trayectosSeleccionados(values) {
  const ida = Boolean(values.hora_recogida && values.hora_llegada);
  const retorno = Boolean(values.hora_retorno_recogida && values.hora_retorno_llegada);
  const incompleto = Boolean(values.hora_recogida) !== Boolean(values.hora_llegada) ||
    Boolean(values.hora_retorno_recogida) !== Boolean(values.hora_retorno_llegada);
  return { ida, retorno, valido: !incompleto && (ida || retorno) };
}
export function horaObligatoria(campo, get) {
  const i = camposHorario.indexOf(campo);
  if (i < 2) return Boolean(get(camposHorario[1-i])) || !(get(camposHorario[2]) && get(camposHorario[3]));
  return Boolean(get(camposHorario[i === 2 ? 3 : 2]));
}
